import gsapUrl from './vendor/gsap.min.js?url';
import draggableUrl from './vendor/Draggable.min.js?url';
import scrollToPluginUrl from './vendor/ScrollToPlugin.min.js?url';
import scrollTriggerUrl from './vendor/ScrollTrigger.min.js?url';
import splitTextUrl from './vendor/SplitText.min.js?url';
import inertiaPluginUrl from './vendor/InertiaPlugin.min.js?url';
import smoothScrollbarUrl from './vendor/smooth-scrollbar.min.js?url';
import splideUrl from './vendor/splide.min.js?url';
import lenisUrl from './vendor/lenis.min.js?url';
import plyrUrl from './vendor/plyr.min.js?url';
import jqueryUrl from './vendor/jquery-3.7.1.min.js?url';
import jcfUrl from './vendor/jcf.js?url';
import jcfCheckboxUrl from './vendor/jcf.checkbox.js?url';
import jcfSelectUrl from './vendor/jcf.select.js?url';
import jcfRadioUrl from './vendor/jcf.radio.js?url';

const loadVendorScript = src => new Promise((resolve, reject) => {
  const existingScript = document.querySelector(`script[src="${src}"]`);

  if (existingScript) {
    if (existingScript.dataset.loaded === 'true') {
      resolve();
      return;
    }

    existingScript.addEventListener('load', () => resolve(), { once: true });
    existingScript.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), { once: true });
    return;
  }

  const script = document.createElement('script');
  script.src = src;
  script.async = false;
  script.dataset.cmpthVendor = 'true';
  script.addEventListener('load', () => {
    script.dataset.loaded = 'true';
    resolve();
  }, { once: true });
  script.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), { once: true });
  document.head.appendChild(script);
});

const loadVendorScripts = async urls => {
  for (const url of urls) {
    await loadVendorScript(url);
  }
};

const initialiseVendorScripts = async () => {
  if (!window.jQuery) {
    await loadVendorScript(jqueryUrl);
  }

  window.jQuery = window.jQuery || window.$;
  window.$ = window.$ || window.jQuery;

  await loadVendorScripts([
    gsapUrl,
    draggableUrl,
    scrollToPluginUrl,
    scrollTriggerUrl,
    splitTextUrl,
    inertiaPluginUrl,
    smoothScrollbarUrl,
    splideUrl,
    lenisUrl,
    plyrUrl,
  ]);

  const globals = {
    jQuery: window.jQuery || window.$,
    $: window.$ || window.jQuery,
    gsap: window.gsap,
    ScrollTrigger: window.ScrollTrigger,
    Draggable: window.Draggable,
    SplitText: window.SplitText,
    InertiaPlugin: window.InertiaPlugin,
    ScrollToPlugin: window.ScrollToPlugin,
    Scrollbar: window.Scrollbar,
    Splide: window.Splide,
    Lenis: window.Lenis,
    Plyr: window.Plyr,
    jcf: window.jcf,
  };

  Object.entries(globals).forEach(([key, value]) => {
    if (value) {
      window[key] = value;
      globalThis[key] = value;
    }
  });

  if (window.gsap) {
    const plugins = [
      window.ScrollTrigger,
      window.Draggable,
      window.InertiaPlugin,
      window.ScrollToPlugin,
      window.SplitText,
    ].filter(Boolean);

    if (plugins.length) {
      window.gsap.registerPlugin(...plugins);
    }
  }

  await loadVendorScripts([
    jcfUrl,
    jcfCheckboxUrl,
    jcfSelectUrl,
    jcfRadioUrl,
  ]);

  if (window.jcf) {
    window.jQuery = window.jQuery || window.$;
    window.$ = window.$ || window.jQuery;
    window.jcf = window.jcf;
    globalThis.jcf = window.jcf;
  }
};

export const vendorReady = initialiseVendorScripts().catch(error => {
  console.error('cmpth vendor bootstrap failed', error);
  throw error;
});
